var map = {
	"./audioCorrect.png": "b2a5",
	"./audioWrong.png": "5138",
	"./correct.png": "85bc",
	"./correctNumberStar.png": "0eb7",
	"./default.png": "9eb8",
	"./wrong.png": "b7f4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "19ba";